import { BerthResponse, BerthsApi, CreateBerthRequest, UpdateBerthRequest } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

export class BerthService {
  private readonly httpClient = createApiClient(BerthsApi)

  async list(): Promise<BerthResponse[]> {
    const { data } = await this.httpClient.getBerths()

    return data.berths
  }

  async create(request: CreateBerthRequest): Promise<string> {
    const { data } = await this.httpClient.createBerth(request)
    return data.id
  }

  async update(request: UpdateBerthRequest): Promise<void> {
    await this.httpClient.updateBerth(request)
  }

  async delete(id: string): Promise<void> {
    await this.httpClient.deleteBerth({ id })
  }
}

export const berthService = new BerthService()
